<template>
  <li v-if="UserCan(item.permissions)">
    <component
      :is="componentIs"
      :to="itemTo"
      :href="itemHref || route(itemRoute)"
      exact-active-class="bg-gray-700"
      class="flex text-gray-300 cursor-pointer hover:bg-gray-700 items-center"
      :class="{'py-2': !isSubmenuList, 'p-3 text-sm': isSubmenuList, 'bg-gray-700': itemRoute ? route().current(itemRoute) : false}"
      @click="menuClick"
    >
      <icon v-if="item.icon" :path="item.icon" class="flex-none" w="w-12" />
      <span class="flex-grow text-sm">
          {{ item.label }}
      </span>
      <icon v-if="hasDropdown" :path="dropdownIcon" class="flex-none" w="w-12" />
    </component>
    <aside-menu-list
      v-if="hasDropdown"
      :menu="item.menu"
      :class="{ 'hidden': !isDropdownActive, 'block bg-gray-600': isDropdownActive }"
      is-submenu-list
    />
  </li>
</template>

<script>
import { defineAsyncComponent, ref, computed } from 'vue'
import { mdiMinus, mdiPlus } from '@mdi/js'
import Icon from '@/Components/Dashboard/Icon'

export default {
  name: 'AsideMenuItem',
  components: {
    AsideMenuList: defineAsyncComponent(() => import('@/Components/Dashboard/AsideMenuList')),
    Icon
  },
  emits: ['menu-click'],
  props: {
    item: {
      type: [Object, Boolean, String],
      default: null
    },
    isSubmenuList: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const self = this

    const isDropdownActive = ref(false)

    const componentIs = computed(() => props.item.to ? 'router-link' : 'a')

    const hasDropdown = computed(() => !!props.item.menu)

    const dropdownIcon = computed(() => isDropdownActive.value ? mdiMinus : mdiPlus)

    const itemTo = computed(() => props.item.to || null)

    const itemRoute = computed(() => props.item.route || null)

    const itemHref = computed(() => props.item.href || null)

    const menuClick = event => {
      emit('menu-click', event, props.item)

      if (hasDropdown.value) {
        isDropdownActive.value = !isDropdownActive.value
      }
    }

    return {
      isDropdownActive,
      componentIs,
      hasDropdown,
      dropdownIcon,
      itemTo,
      itemHref,
      itemRoute,
      menuClick,
    }
  }
}
</script>
